
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-icon",classNames,staticClass],
              style: [{"vertical-align":"middle"},style,staticStyle],
              attrs: Object.assign({"style":"vertical-align:middle","viewBox":"85 115 850 795","xmlns":"http://www.w3.org/2000/svg","overflow":"hidden"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M565.3 148.3l365.1 669.4c11.1 20 10.8 39.9-1 59.9-5.4 9.2-12.8 16.5-22.1 21.9-9.4 5.4-19.4 8.1-30.2 8.1H146.8c-10.8 0-20.8-2.7-30.2-8.1-9.4-5.4-16.7-12.7-22.1-21.9-11.7-20-12-39.9-1-59.9l365.2-669.5c5.4-9.8 12.8-17.6 22.3-23.3 9.5-5.7 19.8-8.6 30.9-8.6s21.4 2.9 30.9 8.6c9.6 5.8 17.1 13.6 22.5 23.4zm6.6 444.2l8.6-218.2c0-3.8-1.6-6.8-4.8-9-4.1-3.5-7.9-5.2-11.4-5.2H459.7c-3.5 0-7.3 1.7-11.4 5.2-3.2 2.2-4.8 5.5-4.8 10l8.1 217.3c0 3.2 1.6 5.8 4.8 7.8 3.2 2.1 7 3.1 11.4 3.1h88c4.4 0 8.2-1 11.2-3.1 2.9-2.1 4.6-4.9 4.9-7.9zm1 177.8V680c0-4.4-1.5-8.2-4.5-11.2s-6.6-4.5-10.7-4.5h-91.3c-4.1 0-7.7 1.5-10.7 4.5s-4.5 6.7-4.5 11.2v90.3c0 4.4 1.5 8.2 4.5 11.2s6.6 4.5 10.7 4.5h91.3c4.1 0 7.7-1.5 10.7-4.5s4.5-6.8 4.5-11.2z"}})])
          )
        }
      }
    